//------ 视口选择显示属性面板 开始------
import {
  EditorPanelEventName,
  EditorPanelShowPropertyReason,
  useDispatchEvent,
  type EditorPanelShowPropertyRequestedEventPayload,
} from '@puppycad/cad-core';

/**
 * 请求编辑器右侧面板切换到属性面板。
 *
 * 设计说明：
 * 1. 选择订阅层只发布“应显示属性面板”的意图，不直接持有右侧 tab 响应式状态；
 * 2. Editor.vue 统一监听 cad-core 事件并完成实际切换，避免选择流和 UI 宿主互相耦合。
 *
 * @param reason 本次请求的触发原因。
 * @param primaryObjectId 本次选择中的主对象 ID。
 * @param selectedObjectCount 本次选择中的对象数量。
 */
export function requestEditorPropertyTab(
  reason: EditorPanelShowPropertyReason,
  primaryObjectId: string | null,
  selectedObjectCount: number,
): void {
  const payload: EditorPanelShowPropertyRequestedEventPayload = {
    reason,
    primaryObjectId,
    selectedObjectCount,
  };

  // 通过 cad-core 事件总线广播右侧面板切换意图，由 Editor.vue 监听后切换 tab。
  useDispatchEvent(EditorPanelEventName.ShowPropertyRequested, payload);
}
//------ 视口选择显示属性面板 结束------
